<template>
  <div class="flex" :class="color">
    <div class="dot" :class="color">
      <div class="dot-inner" :class="color"></div>
    </div>
    {{ status }}
  </div>
</template>

<script>
  export default {
    name: "TaskStatus",
    props:{
      color:{
        type:String,
        required:true
      },
      status:{
        type:String,
        required:true
      }
    },
  }
</script>

<style scoped>
  .flex{
    display: flex;
    align-items: center;
  }
  .dot{
    width:0.83rem;
    height: 0.83rem;
    border-radius: 50%;
    border:1px solid transparent;
    padding:2px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
  }
  .dot .dot-inner{
    width: 0.33rem;
    height: 0.33rem;
    background: transparent;
    border-radius: 50%;
  }

  .dot.info{
    border-color: #2196f3;
  }
  .dot.warning{
    border-color:#F2A138;
  }
  .dot.danger{
    border-color:#FF2900;
  }
  .dot.success{
    border-color:#21B811;
  }
  .dot.secondary{
    border-color: #ccc;
  }
  .dot .dot-inner.info{
    background:#2196f3;
  }
  .dot .dot-inner.warning{
    background:#F2A138;
  }
  .dot .dot-inner.danger{
    background:#FF2900;
  }
  .dot .dot-inner.success{
    background:#21B811;
  }
  .dot .dot-inner.secondary{
    background:#ccc;
  }
</style>